<section class="delete-dialog">

  <div class="dialog-icon">
    <span class="icon-circle">
      <mat-icon>priority_high</mat-icon>
    </span>
  </div>

  <h2 class="dialog-title font-600">Tem certeza que deseja excluir este produto?</h2>

  <p class="dialog-message font-400" *ngIf="message; else defaultMessage">
    {{ message }}
  </p>
  <ng-template #defaultMessage>
    <p class="dialog-message font-400">
      Ao excluir, o produto <strong>{{ itemName }}</strong> sera removido
      permanentemente da sua lista.
    </p>
  </ng-template>

  <div class="dialog-actions">
    <button class="btn-outline font-600" type="button" (click)="onCancel()">
      {{ cancelText }}
    </button>
    <button class="btn-solid font-600" type="button" (click)="onConfirm()">
      {{ confirmText }}
    </button>
  </div>
</section>
